import { computed, Directive, effect, inject, input } from '@angular/core';
import { HlmInput } from '@spartan-ng/helm/input';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
  selector: 'input[hlmInputGroupInput]',
  hostDirectives: [HlmInput],
  host: {
    '[class]': '_computedClass()',
    'data-slot': 'input-group-control',
  },
})
export class HlmInputGroupInput {
  private readonly _hlmInput = inject(HlmInput);

  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    hlm('flex-1 border-0 shadow-none focus-visible:ring-0 component-medium-medium !h-[36px]', this.userClass()),
  );

  constructor() {
    effect(() => {
      this._hlmInput.setClass(this._computedClass());
    });
  }
}
